import { createSlice } from "@reduxjs/toolkit";

const selectedContactSlice = createSlice({
  name: "selectedContact",
  initialState: null,
  reducers: {
    setSelectedContact: (state, action) => {
      return action.payload;
    },
    clearSelectedContact: () => {
      return null;
    },
  },
});

export const { setSelectedContact, clearSelectedContact } =
  selectedContactSlice.actions;
export const selectedSelectedContact = (state) => state.selectedContact;

export default selectedContactSlice.reducer;
